import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import auth from '../../helpers/auth';

class FileInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileError: false,
      newFile: undefined,
      uuid: undefined,
    };
    this.handleFile = this.handleFile.bind(this);
  }

  getNewFilesUuids = () => {
    const { uuid } = this.state;
    return uuid;
  };

  handleFile = (e) => {
    const { uploadUrl } = this.props;
    const { files } = e.target;
    if (files.length > 0) {
      if (files[0].size <= 1e+8) {
        this.setState({
          fileError: false,
        });
        const reader = new FileReader();
        const { name } = e.target.files[0];
        reader.readAsArrayBuffer(files[0]);
        reader.onload = (event) => {
          const body = event.target.result;
          this.uploadFile({
            url: uploadUrl,
            config: { body, name }
          })
        }
      } else {
        this.setState({
          fileError: true
        })
      }
    }
  };

  uploadFile = (object) => {
    auth.fetch(object.url, {
      method: 'PUT',
      body: object.config.body,
      headers: {
        'Content-Disposition': `attachment; filename="${encodeURI(object.config.name)}"`
      }
    })
    .then((response) => {
       this.setState({
         newFile: object.config.name,
         uuid: response.uuid,
       });
    })
  };

  fileDownload(id) {
    const { loginIdToken, downloadUrl } = this.props;
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `${downloadUrl}${id}`, true);
    xhr.responseType = 'blob';
    xhr.setRequestHeader('Authorization', `JWT ${loginIdToken}`);
    xhr.onload = function onload() {
      if (this.status === 200) {
        const content = xhr.getResponseHeader('Content-Disposition');
        let filename = '';
        if (content.includes('filename=')) {
          filename = content.split('filename=')[1].replace(/^"+|"+$/g, '');
        } else {
          filename = decodeURI(content.split('filename*=utf-8\'\'')[1].replace(/^"+|"+$/g, ''));
        }
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(new Blob([this.response]));
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
            document.body.removeChild(link);
        }, 1000);
      }
    };
    xhr.send()
  }

  render() {
    const { file, label, fileExtensions } = this.props;
    const { fileError, newFile, uuid } = this.state;
    return(
      <div className="file-upload d-flex">
        { /* eslint-disable */ }
        <label>
          {label}
          <Input
            type="file"
            name="file"
            id="file"
            invalid
            accept={fileExtensions}
            style={{ marginTop: '15px' }}
            onChange={this.handleFile}
          />
          <div className={!fileError ? 'd-none' : 'invalid-feedback'}>
            Archivo supera el tamaño máximo permitido
          </div>
        </label>
        { /* eslint-enable */ }
        <div className={`file-name ${uuid}`}>
          {newFile}
          {file && (
            <div>
              {file.original_name}
              &nbsp;&nbsp;
              <Button
                className="reactstrap-table-link"
                color="link"
                onClick={() => this.fileDownload(file.id)}
              >
                <FontAwesomeIcon icon={faDownload} />
              </Button>
            </div>
          )}
        </div>
      </div>
    )
  }
}

FileInput.propTypes = {
  file: PropTypes.shape({
    id: PropTypes.number,
    original_name: PropTypes.string,
  }),
  loginIdToken: PropTypes.string,
  uploadUrl: PropTypes.string,
  downloadUrl: PropTypes.string,
  label: PropTypes.string,
  fileExtensions: PropTypes.string,
};

FileInput.defaultProps = {
  downloadUrl: '',
  file: undefined,
  loginIdToken: '',
  uploadUrl: '',
  label: 'Seleccionar archivo',
  fileExtensions: undefined
};

export default FileInput;
